export const GOOGLE_AUTH = 'auth/googleAuth';
export const CREATE_ANONYMOUS_USER = () => `auth/createAnonymous`;
export const GET_ANONYMOUS_USER = () => `auth/getAnonymous`;
